import TierListRoute from "./modules/TierList";
import UpgradeFormRoute from "./modules/UpgradeForm";
import BeeBrokersRoute from "./modules/BeeBrokers";
import PublicCatalogRoute from "./modules/PublicCatalog";


export const TierList = TierListRoute
export const UpgradeForm = UpgradeFormRoute
export const BeeBrokers = BeeBrokersRoute
export const PublicCatalog = PublicCatalogRoute